import * as z from "zod";

export const transactionFormSchema = z.object({
  id: z.number().optional(),
  amount: z.coerce.number({
    required_error: "Amount is required",
    invalid_type_error: "Amount must be a number",
  }),
  occurred: z.date({
    required_error: "Date is required",
  }),
  description: z.string(),
  category: z.coerce.number({
    required_error: "Category is required",
  }),
});

export type TransactionFormValues = z.infer<typeof transactionFormSchema>;
